// extracted by mini-css-extract-plugin
export default {"affiliate__title":"affiliate_affiliate__title__Zzf4H","affiliate__action":"affiliate_affiliate__action__N+Sk1"};